import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import Paper, { paperClasses, PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const StyledPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  [`&.${paperClasses.root}`]: {
    marginBottom: theme.spacing(2),
  },
}));

export const StyledGridItemProductLogo = styled(Grid)<GridProps>(
  ({ theme }) => ({
    [`&.${gridClasses.item}`]: {
      borderRight: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      width: 150,
    },
  }),
);

export const StyledGridItemRegistrationDetails = styled(Grid)<GridProps>(
  ({ theme }) => ({
    [`&.${gridClasses.item}`]: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      padding: theme.spacing(2),
    },
  }),
);

export const StyledGridItemRegistrationActions = styled(Grid)<GridProps>(
  ({ theme }) => ({
    [`&.${gridClasses.item}`]: {
      paddingRight: theme.spacing(2),
    },
  }),
);

export const StyledImg = styled('img')({
  width: '100%',
});
